import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  store: {
    display: "flex",
    flexDirection: "column",
  },
  borderBox: {
    borderBottom: "1px solid " + theme.palette.black.supportLight,
    paddingTop: "25px",
    paddingBottom: "33px",
    paddingRight: "16px",
  },
  title: props => ({
    fontSize:
      props.styling.locationStyling && props.styling.locationStyling.fontSize
        ? parseInt(props.styling.locationStyling.fontSize)
        : 20,
    fontFamily:
      props.styling.locationStyling && props.styling.locationStyling.fontFamily
        ? props.styling.locationStyling.fontFamily
        : ["Proxima Nova", "Roboto", "Helvetica", "Arial", "sans-serif"].join(
            ","
          ),
    fontWeight:
      props.styling.locationStyling && props.styling.locationStyling.fontWeight
        ? parseInt(props.styling.locationStyling.fontWeight)
        : 400,
    letterSpacing:
      props.styling.locationStyling &&
      props.styling.locationStyling.letterSpacing
        ? props.styling.locationStyling.letterSpacing
        : "0px",
    lineHeight:
      props.styling.locationStyling && props.styling.locationStyling.lineHeight
        ? props.styling.locationStyling.lineHeight
        : "32px",
    textTransform:
      props.styling.locationStyling &&
      props.styling.locationStyling.textTransform,
    color:
      props.styling.locationStyling && props.styling.locationStyling.fontColor
        ? props.styling.locationStyling.fontColor
        : "#212221",
  }),
  address: props => ({
    fontSize:
      props.styling.addressStyling && props.styling.addressStyling.fontSize
        ? parseInt(props.styling.addressStyling.fontSize)
        : 20,
    fontFamily:
      props.styling.addressStyling && props.styling.addressStyling.fontFamily
        ? props.styling.addressStyling.fontFamily
        : ["Proxima Nova", "Roboto", "Helvetica", "Arial", "sans-serif"].join(
            ","
          ),
    fontWeight:
      props.styling.addressStyling && props.styling.addressStyling.fontWeight
        ? parseInt(props.styling.addressStyling.fontWeight)
        : 400,
    letterSpacing:
      props.styling.addressStyling && props.styling.addressStyling.letterSpacing
        ? props.styling.addressStyling.letterSpacing
        : "0px",
    lineHeight:
      props.styling.addressStyling && props.styling.addressStyling.lineHeight
        ? props.styling.addressStyling.lineHeight
        : "32px",
    textTransform:
      props.styling.addressStyling &&
      props.styling.addressStyling.textTransform,
    color:
      props.styling.addressStyling && props.styling.addressStyling.fontColor
        ? props.styling.addressStyling.fontColor
        : "#212221",
  }),
}))

export default props => {
  // const storeCount = stores.length
  const classes = useStyles(props)
  return (
    <div className={classes.container}>
      {/* <div className={classes.borderBox}>
        <Typography variant="h3">
          {storeCount} Stores in {province}
        </Typography>
      </div> */}

      {props.stores.map((item, i) => (
        <div key={i} className={classes.borderBox}>
          <div className={classes.title}>{item.next.name}</div>
          <Typography className={classes.address}>
            {item.next.address}
          </Typography>
          <Typography className={classes.address}>
            {item.next.phoneNumber}
          </Typography>
        </div>
      ))}
    </div>
  )
}
